export const DOCS_URL = 'https://splits.org/docs'

export const CHANGELOG_URL = 'https://splits.org/changelog'

const SPLITS_CONNECT_CHROME_STORE_URL =
  'https://chromewebstore.google.com/detail/splits/ghfacfafnbcgkielpaeifdpoggfeakif'

const SPLITS_CONNECT_INSTALL_SURFACES = {
  helpMenu: 'help-menu',
  featureCard: 'feature-card',
  walletConnectDialog: 'wallet-connect-dialog',
  extensionsSettings: 'extensions-settings',
} as const

type SplitsConnectInstallSurface = keyof typeof SPLITS_CONNECT_INSTALL_SURFACES

export const getSplitsConnectInstallAttribution = (
  surface: SplitsConnectInstallSurface,
) => {
  const attributionSource = SPLITS_CONNECT_INSTALL_SURFACES[surface]
  const url = new URL(SPLITS_CONNECT_CHROME_STORE_URL)
  url.searchParams.set('utm_source', attributionSource)
  url.searchParams.set('utm_medium', 'app')
  return {
    url: url.toString(),
    eventProperties: { surface: attributionSource },
  }
}

export const ACCOUNTS_GUIDE_URL = `${DOCS_URL}/accounts`

export const OPERATING_ACCOUNTS_GUIDE_URL = `${DOCS_URL}/accounts#operating-accounts`

export const EXTERNAL_ACCOUNTS_GUIDE_URL = `${DOCS_URL}/accounts#external-accounts`

export const AUTOMATIONS_GUIDE_URL =
  'https://splits.org/docs/accounts#automation-accounts'

export const INVOICES_GUIDE_URL = `${DOCS_URL}/invoicing`

export const SCHEDULES_GUIDE_URL = `${DOCS_URL}/transactions/schedules`

export const EARN_GUIDE_URL = `${DOCS_URL}/accounts/earn/`

export const LEDGER_GUIDE_URL = `${DOCS_URL}/workspaces/recovery#known-issues-when-using-a-ledger`

export const RAIN_DOCS_URL = `${DOCS_URL}/integrations/rain`

export const RAIN_DASHBOARD_URL = 'https://use.rain.xyz'
